"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const grid_1 = __importDefault(require("components/templates/grid"));
const hopper_style_1 = __importDefault(require("../hopper.style"));
const hopper_action_1 = __importDefault(require("../hopper.action"));
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const modal_1 = require("components/molecules/modal");
const hopper_column_1 = require("../hopper.column");
const HopperHistory = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { dataItem, isLoading, dataStates, dataHauler, dataHistory, isSavedData, mutationMode, isGetDataHauler, dataStatesHistory, } = (0, store_1.useAppSelector)((state) => state.hopper);
    const { configurationCheckPointData: dataPos } = (0, store_1.useAppSelector)((state) => state.hopperPos);
    (0, react_1.useEffect)(() => {
        if (isLoading)
            dispatch(hopper_action_1.default.getDataHistory(dataStatesHistory));
    }, [isLoading]);
    const onClickHandle = ({ dataItem }) => {
        dispatch(hopper_action_1.default.onClickMutation({ mutationMode: 'details', dataItemHistory: dataItem, dataItem, dataHauler }));
    };
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { skip: types === 'page' ? (val - 1) * dataStatesHistory.take : 0, take: types === 'take' ? val : dataStatesHistory.take, filter: {
                logic: 'and',
                filters: [{
                        operator: 'uuid',
                        field: 'checkpoint_id',
                        value: dataPos.checkpoint_id
                    }]
            } });
        dispatch(hopper_action_1.default.onDataStateChangeHistory(newDataStates));
    };
    const onSortChange = (e) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { sort: e.sort });
        dispatch(hopper_action_1.default.onSortChange(e.sort));
        dispatch(hopper_action_1.default.getDataHistory(newDataStates));
    };
    const onFilterChange = (e) => {
        const newDataStates = Object.assign(Object.assign({}, dataStatesHistory), { filter: e.filter });
        dispatch(hopper_action_1.default.onFilterChange(e.filter));
        dispatch(hopper_action_1.default.getDataHistory(newDataStates));
    };
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ appTheme: appTheme, modalTitle: 'History', show: mutationMode == 'history', style: hopper_style_1.default.modalContainer(appTheme), handleClose: () => {
            dispatch(hopper_action_1.default.onClickMutation({ mutationMode: false, dataHauler, isGetDataHauler, isSavedData, dataItem }));
        } }, { children: (0, jsx_runtime_1.jsx)(grid_1.default, { cardGrid: false, pageable: true, sortable: true, sort: dataStates.sort, scrollable: dataStatesHistory.scrollable, dataStates: dataStatesHistory, style: hopper_style_1.default.gridHeight, dataGrid: dataHistory, columns: hopper_column_1.hopperHistoryColumnProps, onRowClick: (event) => onClickHandle(event), onPageChange: (v) => onDataStateChange('page', v), onTakeChange: (v) => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange }) })));
};
exports.default = HopperHistory;
